'use strict';

angular.module('mx.components').directive('mxClearPickerBtn', mxClearPickerBtn);

mxClearPickerBtn.$inject = ['$parse', '$compile'];
export default function mxClearPickerBtn($parse, $compile) {
	var ddo = {
		restrict: 'A',
		link: link,
	};

	return ddo;

	function link(scope, element, attrs) {
		if (!attrs.mdFloatingLabel) {
			return;
		}

		var template = [
			'<md-button tabindex="0" ng-hide="vm.disabled || vm._readOnly" ng-class="vm.browseLookup ? \'clear-autocomplete--offset\' : \'\' " class="md-icon-button clear-autocomplete">',
			'<md-icon class="material-icons">clear</md-icon>',
			'</md-button>',
		].join('');

		var linkFn = $compile(template);
		var button = linkFn(scope);
		element.append(button);

		var searchTextModel = $parse(attrs.mdSearchText);

		scope.$watch(searchTextModel, function (searchText) {
			if (searchText && searchText !== '' && searchText !== null) {
				button.addClass('visible');
			} else {
				button.removeClass('visible');
			}
		});

		button.on('click', onClick);

		scope.$on('$destroy', function () {
			button.off('click');
		});

		function onClick() {
			scope.$evalAsync(function () {
				scope.vm.clear();
			});
		}
	}
}
